import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  Modal,
  Heading,
  ContentDisplay,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';

import {
  termsSignature,
  ITerms
} from '@/modules/catalog/services/variable-income';

interface Props {
  data: ITerms;
  templateId: string;
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'accept', request: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsModal',
  props: {
    data: null,
    templateId: null,
    isOpen: { type: Boolean }
  },
  emits: ["close", "accept"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
  (event: 'accept', request: string): void;
}), expose: any, slots: any, attrs: any }) {

const { data, templateId } = __props as {
  data: ITerms;
  templateId: string;
  isOpen: boolean;
};





const isLoading = ref(false);

function goToTerms() {
  window.open(data.url, '_blank');
}

async function fetchAcceptTerms() {
  try {
    isLoading.value = true;

    const { request } = await termsSignature(templateId);

    emit('accept', request);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });

    emit('close');
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,emit, isLoading, goToTerms, fetchAcceptTerms, Modal, Heading, ContentDisplay, BaseText, ButtonContainer, ButtonPrimary, ButtonSecondary, Portal }
}

})